<template>
  <div v-if="isVisible">
    <base-modal v-model="isVisible">
        <b-row>
            <b-col class="text-center px-2 my-2" sm="12" md="6">
                <base-button @click="showGrantAccess = true">{{$t('clinic-history.grant-access')}}</base-button>
            </b-col>
            <b-col class="text-center px-2 my-2" sm="12" md="6">
                <base-button white @click="showProfAndCenterAuthorizedModal = true">{{$t('clinic-history.access-authorizated')}}</base-button>
            </b-col>
        </b-row>
    </base-modal>
    <history-prof-and-center-authorized v-model="showProfAndCenterAuthorizedModal"></history-prof-and-center-authorized>
    <history-grant-access v-model="showGrantAccess"></history-grant-access>
  </div>
</template>

<script>
import HistoryProfAndCenterAuthorized from '@/components/shared/HistoryProfAndCenterAuthorized'
import HistoryGrantAccess from '@/components/shared/HistoryGrantAccess'
import BaseModal from '@/components/base/BaseModal'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

export default {
    components: {
        HistoryProfAndCenterAuthorized,
        HistoryGrantAccess,
        BaseModal
    },
    mixins: [i18nMixin(I18N_FILE)],
    data () {
        return {
            showProfAndCenterAuthorizedModal: false,
            showGrantAccess: false
        }
    },
    props: {
        value: Boolean
    },
    methods: {
    },
    computed: {
		isVisible: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
	}
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryGrantAccessMenu.vue